<template>
  <div>
    <Table border :height="height" ref="table" :columns="innerColumns" :data="tableData" :stripe="stripe" size="large"
          :row-class-name="rowClassName"
          @on-selection-change="selectionChange" @on-sort-change="handleSortChange"></Table>
    <Page style="margin-top: 10px" :total="totalCount" show-elevator className="page" :current="page.pageIndex"
          :pageSize="page.pageSize" :show-sizer="showSizer" :page-size-opts="pageSizeOpts"
          :placement="showSizer ? 'top' : 'bottom'"
          @on-change="changePageIndex" @on-page-size-change="changePageSize" show-total></Page>
  </div>
</template>
<script>
export default {
  name: 'List',
  props: {
    listUrl: {
      type: [String],
      default () {
        return ''
      }
    },
    params: {
      type: [Object],
      default () {
        return {}
      }
    },
    tableColumns: {
      type: Array,
      default () {
        return []
      }
    },
    reload: {
      type: Number,
      default () {
        return new Date().getTime()
      }
    },
    reloadWithPage: {
      type: Number,
      default () {
        return new Date().getTime()
      }
    },
    onLoading: {
      type: Function,
      default () {
        return null
      }
    },
    pageSize: {
      type: Number,
      default () {
        return 10
      }
    },
    showSizer: {
      type: Boolean,
      default: false
    },
    pageSizeOpts: {
      type: Array,
      default () {
        return [10, 20, 50, 100]
      }
    },
    syncRoute: {
      type: Boolean,
      default () {
        return true
      }
    },
    height: null,
    stripe: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      type: Function,
      default () {
        return function () {
          return ''
        }
      }
    }
  },
  data () {
    return {
      innerColumns: this.tableColumns,
      tableData: [],
      queryParam: {},
      totalCount: 0,
      page: {
        pageIndex: 1,
        pageSize: this.pageSize
      },
      ignorePageChange: false,
      lastId: null  // 存储最后一条数据的ID
    }
  },
  mounted: function () {},
  methods: {
    search () {
      this.searchList('init')
    },
    searchList (type) {
      let self = this
      if (!this.listUrl) {
        return
      }
      if (type === 'init') {
        this.page.pageIndex = 1
        this.lastId = null  // 初始化时清空lastId
      }

      this.queryParam = {}
      this.$helper.mergeProperties(this.params, this.queryParam)
      this.$helper.mergeProperties(this.page, this.queryParam)

      // 添加minId参数
      if (this.lastId !== null && this.lastId !== undefined && this.lastId !== '') {
        this.queryParam.minId = this.lastId
      } else {
        // 如果lastId无效，则从查询参数中移除minId
        delete this.queryParam.minId
      }

      this.handleLoading(true)
      const loading = this.$Message.loading({
        content: '服务器疯狂处理中...',
        duration: 0
      })
      this.$http.post(this.listUrl, self.queryParam).then(function (res) {
        self.tableData = res.data.data || []

        // 获取最后一条数据的ID作为minId的值
        if (self.tableData && self.tableData.length > 0) {
          const lastItem = self.tableData[self.tableData.length - 1]
          if (lastItem && lastItem.id !== undefined && lastItem.id !== null) {
            self.lastId = lastItem.id
          } else {
            self.lastId = null
          }
        } else {
          self.lastId = null
        }

        self.totalCount = res.data.totalCount
        self.handleLoading(false)

        if (self.syncRoute) {
          self.$router.replace({
            query: self.queryParam
          })
        }
        loading()
      }).catch(function (e) {
        console.log(e)
        self.handleLoading(false)
        loading()
      })
    },
    changePageIndex (page) {
      if (this.ignorePageChange) {
        this.ignorePageChange = false
        return
      }
      this.page.pageIndex = page
      this.searchList()
    },
    changePageSize (size) {
      this.page.pageSize = size
      this.ignorePageChange = true
      this.searchList('init')
      let self = this
      this.$nextTick(function () {
        self.ignorePageChange = false
      })
    },
    handleLoading (loading) {
      if (this.onLoading) {
        this.onLoading(loading)
      }
    },
    selectionChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    handleSortChange (column) {
      // 发送排序变更事件给父组件
      // 注意：iview的sortType为'normal'时表示取消排序
      let order = column.order
      if (order === 'normal') {
        order = ''
      }
      this.$emit('on-sort-change', column, column.key, order)
    }
  },
  watch: {
    params (val) {
      this.queryParam = val
    },
    reload (val) {
      if (val) {
        // 当前页面刷新，不重置页码
        if (val === 119) {
          this.searchList()
          return
        }
        this.searchList('init')
      }
    },
    tableColumns (val) {
      this.innerColumns = val
    },
    listUrl (val) {
      if (val) {
        this.searchList('init')
      }
    },
    reloadWithPage (val) {
      if (val) {
        this.searchList()
      }
    },
    pageSize (val) {
      if (val) {
        this.page.pageSize = val
      } else {
        this.page.pageSize = 10
      }
    }
  },
  created: function () {
    if (this.syncRoute === false) {
      this.searchList()
      return
    }
    let routeQuery = this.$route.query
    routeQuery.pageIndex && (this.page.pageIndex = parseInt(routeQuery.pageIndex))
    routeQuery.pageSize && (this.page.pageSize = parseInt(routeQuery.pageSize))
    delete routeQuery.pageIndex
    delete routeQuery.pageSize
    Object.assign(this.params, routeQuery)
    this.searchList()
  }
}

</script>


<style lang="css" scoped>
.page {
  text-align: right;
}
.page /deep/ .ivu-page-options-sizer {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// List.vue?735552f9